import React from 'react';
import axios from 'axios';
import { DateUtils } from '@aws-amplify/core';

type AppInitResponse = {
  clockOffset: number;
};

export const useInitApp = () => {
  /**
   * Initialize the app. Call app server to set default values for the app.
   * ClockSkew is returned based on the time difference between the app server and the user's device.
   */
  const init = async () => {
    const { data } = await axios.get<AppInitResponse>('/init', {
      params: {
        timestamp: new Date().getTime(),
      },
    });

    DateUtils.setClockOffset(data.clockOffset); // set clock offset based on diff from server
  };

  React.useEffect(() => {
    init();
  });
};
